import React, { FC } from 'react';
import { push } from 'redux-first-history';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import { TabsPanel } from '@dev/ee-components';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import useMobile from '@/services/hooks/useMobile';
import { ContactsPaths } from '@/services/dictionaries/Paths';
import { getAccountAccessLevel } from '@/store/account/actions';

import { useSelectedEntity } from '../../hooks';
import { HeaderContainer } from '../StyledComponents';
import { AddContactsButton } from './components/AddContactsButton';
import { HeaderActions } from './components/HeaderActions';
import { TitleWithCount } from './components/HeaderTitle';
import { isPaidSubscriptionList } from '@/components/Contacts/helperFunctions';

export const ContactsListHeader: FC = (): JSX.Element => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const accessLevels = useSelector(getAccountAccessLevel);
    const dispatch = useDispatch();

    const { selectedEntity, isSelectedEntityAList, isBlockedOrStaleSegment } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);
    const isPaidList = isList && isPaidSubscriptionList(selectedEntity);
    const canModifyContacts = accessLevels.includes(AccessLevel.ModifyContacts);

    return (
        <HeaderContainer disableTopMargin={isBlockedOrStaleSegment}>
            <TabsPanel
                title={<TitleWithCount />}
                breadcrumbs={isList ? t('lists') : t('segments')}
                breadcrumbsOnClick={(): void => {
                    dispatch(push(isList ? ContactsPaths.Lists : ContactsPaths.Segments));
                }}
                isMobile={isMobile}
                additionalHeaderContent={
                    canModifyContacts && ((isList && !isPaidList) || (!isList && selectedEntity?.IsAllContacts)) && <AddContactsButton />
                }
                titleSmColumnSizeNumber={10}
            />

            {!isBlockedOrStaleSegment && <HeaderActions />}
        </HeaderContainer>
    );
};
